import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { useCookies } from 'react-cookie'

import { withUserStore } from '../../contexts/UserStore'
import Header from './Header'
import { PresenceBar } from '@byscott-io/corebyscott'
import { usePresenceRoster } from '@byscott-io/where-is-waldo'
import Profile from './Profile'
import Accounts from './Accounts'
import Footer from './Footer'
import PageWrapper from '../Shared/PageWrapper'
import PrioritizePlusContainer from './Container'
import { withModals } from '../../contexts/modals'
import Tours from '../../contexts/tours'

// Who else from this account is here right now. Mounted here, inside the
// protected /app tree, rather than in AppWrapper -- that wraps the marketing
// routes too, and a signed-out visitor has no roster to show and no reason to
// open a cable connection. Core cannot call waldo itself, so the roster is
// resolved here and passed in.
const OnlineNow = () => {
  const { online, connected } = usePresenceRoster()
  return <PresenceBar members={online} connected={connected} />
}

// Component to handle /app route and redirect to appropriate account
const AppRedirect = ({ userStore }) => {
  const navigate = useNavigate()
  const [cookies] = useCookies(['lastAccountId'])
  
  useEffect(() => {
    if (userStore.accounts && userStore.accounts.length > 0) {
      // Use lastAccountId from cookie, or fall back to first account
      const targetAccountId = cookies.lastAccountId || userStore.accounts[0].id
      navigate(`/app/${targetAccountId}`, { replace: true })
    }
  }, [userStore.accounts, cookies.lastAccountId, navigate])
  
  return <div>Loading...</div>
}

const PrioritizePlusRoot = ({ userStore, ...props }) => {
  const location = useLocation()

  // Extract accountId from URL and set it in UserStore for all routes
  // This ensures proper account loading even for routes like /app/organizations  
  useEffect(() => {
    const pathMatch = location.pathname.match(/^\/app\/(\d+)/)
    if (pathMatch && pathMatch[1]) {
      const accountId = parseInt(pathMatch[1])
      // Only update if different to avoid unnecessary re-renders
      if (userStore.accountId !== accountId) {
        userStore.setAccountId(accountId)
      }
    }
  }, [location.pathname, userStore])

  return (
    <Tours>
      <div className="container proxima-nova">
        <OnlineNow />
        <Header />
        <div className="page-content text-normal full-height container">
          <Routes>
            <Route path=":accountId/*" element={<PrioritizePlusContainer {...props} />} />
            <Route path="profile/*" element={<PageWrapper name="Profile"><Profile /></PageWrapper>} />
            <Route path="organizations" element={<PageWrapper name="Accounts"><Accounts /></PageWrapper>} />
            <Route path="/" element={<AppRedirect userStore={userStore} />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Tours>
  )
}

export default withUserStore(withModals(PrioritizePlusRoot))
